import React from 'react';
import AgendamentosSetorial from '../AgendamentosSetorial';
export default function AgendamentoMedico() { return <AgendamentosSetorial setor="medico" />; }
